import React from "react";
import { motion } from "framer-motion";
import styles from "./AutonomousAP.module.css";
import { landStoryIds } from "../../interfaces";
interface SlideNavProps {
  activeSlide: number;
  activeStoryId: landStoryIds;
  callSlideid?: (element: Element, slideIndex: number) => void;

  navHome?: () => void;
}

const slides = [
  { title: "" },
  { title: "Current State." },
  { title: "Our Solution!" },
  { title: "What you get?" },
  { title: "Try It!" },
];
const circleColors = [
  { color: "#2c7395" },
  { color: "#ffb300ff" },
  { color: "#52759b" },
{ color: "#78be46" },
  { color: "#44ff00ff" },
];
const circleInner = [
  { color: "#a9e8ff" },
  { color: "#92683c" },
  { color: "#78fac6" },
  { color: "#57593f" },
  { color: "#04d800ff" },
];
const SlideNav: React.FC<SlideNavProps> = ({ activeSlide, activeStoryId, callSlideid, navHome }) => {
  return (
    <div className={styles.slideNav} >
      {slides.map((slide, i) => {
        const isActive = activeSlide === i + 1 || (activeSlide === 0 && i === 0);
        const circleRadius = 6;
        const circumference = 2 * Math.PI * circleRadius;
        return (
          <div key={i} className={styles.navItem} >
            <div
              className={styles.dotWrapper}
              onClick={() => {
                let storyPre = activeStoryId === "acc" ? "cc" : "bg";
                const elements = document.querySelectorAll('[data-bg="' + storyPre + (i + 1) + '"]');
                if (i === 0) {
                  navHome && navHome();
                }  else {
                  if (elements.length > 0) callSlideid && callSlideid(elements[0], i);
                }
              }}
            >
              <motion.svg
                width={26}
                height={26}
                viewBox="0 0 16 16"
                className={styles.dotCircle}
              >
                {/* Solid background circle */}
              <motion.circle
                cx="8"
                cy="8"
                r={circleRadius}
                animate={{ fill: isActive ? circleInner[i].color : "#fff" }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
                stroke="none"
              />
                {/* Animated circle stroke */}
                <motion.circle
                  cx="8"
                  cy="8"
                  r={circleRadius}
                  fill="none"
                  stroke={circleColors[i].color}
                  strokeWidth="4"
                  strokeDasharray={circumference}
                  strokeDashoffset={circumference}
                  animate={{ strokeDashoffset: isActive ? 0 : circumference }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                />
              </motion.svg>

            </div>
            {i === 0 && (
                <div className={styles.homeNav}  onClick={() => {navHome && navHome()}}>Home</div>
            )}

            <motion.span
              className={styles.navLabel}
              style={{ textShadow: isActive ? "0 0 3px rgba(90, 90, 90, 0.8)" : "0 2px 3px rgba(90, 90, 90, 0.8)" }}
              animate={{
                opacity: 1,
                color: "#ffffffff",
                fontVariationSettings: `"wght" ${isActive ? 800 : 500}`,
              }}
              transition={{ duration: 0.4 }}
            >
              <div className={styles.slideNavTitleDiv} onClick={() => {
                let storyPre = activeStoryId === "acc" ? "cc" : "bg";
                const elements = document.querySelectorAll('[data-bg="' + storyPre + (i + 1) + '"]');
                if (elements.length > 0) callSlideid && callSlideid(elements[0], i);
              }}>
                {slide.title}
              </div>
            </motion.span>
          </div>
        );
      })}

      {/* Vertical line */}
        <motion.div
        className={styles.navLine}
        initial={{ height: 0 }}
        animate={{
            height: (() => {
            const items = document.querySelectorAll(`.${styles.navItem}`);
            if (items.length === 0) return 0;
            const first = items[0] as HTMLElement;
            const active = items[activeSlide - 1] as HTMLElement;
            if (!active) return 0;
            return active.offsetTop + active.offsetHeight / 2 - first.offsetTop;
            })(),
        }}
        transition={{ duration: 0.4, ease: "easeIn" }}
        />
    </div>
  );
};

export default SlideNav;
